// src/components/Navbar.js

import React, { useState, useEffect, useRef } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './Navbar.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import { APP_STORE_URL } from '../utils/site';

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const navRef = useRef();

  const handleToggle = () => {
    setIsMobile(!isMobile);
  };

  const closeMobileMenu = () => {
    setIsMobile(false);
  };

  const handleClickOutside = (event) => {
    if (navRef.current && !navRef.current.contains(event.target)) {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto'; // Restore scrolling
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [isMobile]);

  return (
    <nav className="navbar" ref={navRef}>
      <Link to="/" className="navbar-logo">
        <img src="/icon.png" alt="Recalls365 icon" className="navbar-logo-icon" />
        Recalls365
      </Link>
      <button
        className="menu-icon"
        onClick={handleToggle}
        aria-label={isMobile ? 'Close Menu' : 'Open Menu'}
        aria-expanded={isMobile}
      >
        {isMobile ? <FaTimes /> : <FaBars />}
      </button>
      <ul className={isMobile ? 'nav-links mobile' : 'nav-links'}>
        <li>
          <NavLink to="/" end className={({ isActive }) => (isActive ? 'active-link' : '')} onClick={closeMobileMenu}>
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/blog" className={({ isActive }) => (isActive ? 'active-link' : '')} onClick={closeMobileMenu}>
            Blog
          </NavLink>
        </li>
        <li>
          <NavLink to="/guides" className={({ isActive }) => (isActive ? 'active-link' : '')} onClick={closeMobileMenu}>
            Guides
          </NavLink>
        </li>
        <li>
          <NavLink to="/latest-recalls" className={({ isActive }) => (isActive ? 'active-link' : '')} onClick={closeMobileMenu}>
            Latest Recalls
          </NavLink>
        </li>
        <li>
          <NavLink to="/about" className={({ isActive }) => (isActive ? 'active-link' : '')} onClick={closeMobileMenu}>
            About
          </NavLink>
        </li>
        <li>
          <NavLink to="/contact" className={({ isActive }) => (isActive ? 'active-link' : '')} onClick={closeMobileMenu}>
            Contact
          </NavLink>
        </li>
        <li className="nav-cta">
          <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>
            Get the App
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
